export default __webpack_public_path__ + "pick-box-2edf3e8e08add6f8a8122e4344bcd75f.mp3";